import React from "react";

import { Avatar, AvatarProfile, Text } from "@performyard/py-components";

import avatarURL from "../../../../utils/avatarURL";

import { type AssigneeValue, getAssigneeWildcard } from "../launch-form";

/**
 * Avatar + name for an assignee, whether a real employee or one of the wildcard
 * references. Shared by the assignee picker (selected value and options) and the
 * signature template details modal so both render signers identically.
 */
export const AssigneeLabel = ({ assignee }: { assignee: AssigneeValue }) => {
	const wildcard = getAssigneeWildcard(assignee.id);
	if (wildcard) {
		return (
			<div className="grid grid-cols-[auto_1fr] items-center gap-1">
				{/* The wildcards have no user to avatar; the legacy picker's generated
				    initial images (E / EM / OE) keep them visually distinct. */}
				<Avatar size={20} url={avatarURL(wildcard.avatarInitials, 0)} name={wildcard.name} />
				<Text size="paragraph-3" weight="regular" wrap={false} dangerouslySetClassName="py-text-truncate">
					{wildcard.name}
				</Text>
			</div>
		);
	}
	return <AvatarProfile employeeId={assignee.id} employeeName={assignee.name} avatarSize={20} noLink />;
};
